import { render } from "./component-adress-korp.vue?vue&type=template&id=35037cf5"
import script from "./component-adress-korp.vue?vue&type=script&setup=true&lang=js"
export * from "./component-adress-korp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-adress-korp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35037cf5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35037cf5', __exports__)) {
    api.reload('35037cf5', __exports__)
  }
  
  module.hot.accept("./component-adress-korp.vue?vue&type=template&id=35037cf5", () => {
    api.rerender('35037cf5', render)
  })

}


export default __exports__